import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import ConversionTableSheet from './ConversionTableSheet';

class ConversionTable extends Component {
  render() {
    const {
      curFrom, curTo, rateDate, rate, rateInverted, fee,
    } = this.props;
    return (
      <div>
        <Grid container spacing={16}>
          <Grid item xs={12} md={6} className="conversion-table__sheet">
            <ConversionTableSheet
              fee={fee}
              rate={rate}
              curFrom={curFrom}
              curTo={curTo}
              rateDate={rateDate}
            />
          </Grid>

          <Grid item xs={12} md={6} className="conversion-table__sheet">
            <ConversionTableSheet
              fee={fee}
              rate={rateInverted}
              curFrom={curTo}
              curTo={curFrom}
              rateDate={rateDate}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

ConversionTable.propTypes = {
  curFrom: PropTypes.instanceOf(Object).isRequired,
  curTo: PropTypes.instanceOf(Object).isRequired,
  fee: PropTypes.number.isRequired,
  rateDate: PropTypes.instanceOf(Date).isRequired,
  rate: PropTypes.number.isRequired,
  rateInverted: PropTypes.number.isRequired,
};

export default ConversionTable;



// WEBPACK FOOTER //
// ./src/components/calculator/conversion-table/ConversionTable.js